module.exports = __webpack_public_path__ + "img/stinger-19.134520bf.png";